import React from "react";
import { createBLoC, useInitBLoC, IBLoC, BLoCCallback, BLoCBase } from "@rsm";
import { ChartDownloadButtonActions } from "./ChartDownloadButton";
import { distinctUntilChanged } from "rxjs";

type State = {
  chartActions: { [key: string]: ChartDownloadButtonActions };
};

class BLoC extends BLoCBase<State> implements IBLoC {
  public readonly chartActions$ = this.getState$("chartActions").pipe(distinctUntilChanged());
  constructor() {
    super({
      chartActions: {
        default: {
          downloadImageTargetId: undefined,
          downloadChartTitle: undefined,
          downloadCSVCallback: undefined,
          downloadXLSCallback: undefined,
          getDataForXLSXCallback: undefined,
        },
      },
    });
  }
  public onInit() {}

  public setChartDownloadActions = (chartActions: ChartDownloadButtonActions, name?: string) => {
    this.mutateState("chartActions", (prev) => {
      const key = name ?? "default";
      const prevActions = prev[key];
      return {
        ...prev,
        [key]: {
          ...prevActions,
          ...chartActions,
          downloadDate:
            "downloadDate" in chartActions ? chartActions.downloadDate : prevActions?.downloadDate,
        },
      };
    });
  };

  public setDownloadDate = (downloadDate: Date, name?: string) => {
    this.mutateState("chartActions", (prev) => ({
      ...prev,
      [name ?? "default"]: { ...prev[name ?? "default"], downloadDate },
    }));
  };
}

const [ContextWrapper, useBloc] = createBLoC<BLoC>();

export const useChartDownloadButtonBLoC = useBloc;

export const ChartDownloadButtonBLoC: React.FC<BLoCCallback<BLoC>> = ({ children }) => {
  const bloc = useInitBLoC(() => new BLoC(), []);
  return bloc ? <ContextWrapper bloc={bloc} children={children} /> : null;
};
